export enum TaskName {
  APPLICANT = 'APPLICANT',
  VERIFICATIONS = 'VERIFICATIONS',
  COMPLETE = 'COMPLETE',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  HANDOFF = 'HANDOFF',
}
